import styled from 'styled-components';

export default styled.div`
  text-align: left;

  .title {
    margin: 15px 0 30px;
    text-align: center;
    & span {
      font-size: 24px;
      font-weight: 300;
      line-height: 1;
      text-transform: uppercase;
      color: #788195;
    }
  }

  .status-card {
    background: #fff;
    border-radius: 6px;
    padding: 16px;
    margin-bottom: 20px;
    font-size: 13px;
    word-break: break-all;

    .row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      & .label {
        color: #7b8794;
        margin-right: 10px;
        white-space: nowrap;
      }
      & .value {
        text-align: right;
      }
    }
  }

  .advanced {
    margin: 10px 0 20px;
    .ant-input {
      margin-bottom: 10px;
    }
  }

  .action-div {
    & button {
      width: 100%;
      margin-bottom: 10px;
    }
  }

  .hint {
    color: #7b8794;
    font-size: 12px;
    margin-top: 10px;
  }
`;
